// Copyright © 2026 ApexRuntime Labs by Shashi (https://github.com/spshah). All rights reserved.

import React, { useState, useEffect, Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';

export function EditBalance({ isOpen, handleState, currentBalance, handleCurrentBalance }) {
  const [balance, setBalance] = useState(0);

  useEffect(() => {
    setBalance(currentBalance);
  }, [currentBalance]);

  function closeModal() {
    handleState(false);
  }

  function updateBalance() {
    // handleCurrentBalance(balance);
    // walletService.
    closeModal();
  }

  function handleBalanceChange(event) {
    setBalance(event.target.value);
  }

  return (
    <>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={closeModal}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-black-400 p-6 text-left align-middle shadow-xl transition-all">
                  <Dialog.Title
                    as="h3"
                    className="text-lg font-medium leading-6 mb-4 text-gray-900"
                  >
                    Balance Settings
                  </Dialog.Title>
                  <form className="mt-2 mb-4">
                    <div className="flex flex-row gap-1 items-center">
                      <span>$</span>
                      <input
                        type="number"
                        value={balance}
                        onChange={handleBalanceChange}
                        className="p-2"
                      />
                    </div>
                    <small className="text-sm text-gray-500">
                      You can change it whenever you want.
                    </small>
                  </form>

                  <div className="mt-4">
                    <button
                      type="button"
                      className="inline-flex justify-center rounded-md border border-transparent bg-blue-100 px-4 py-2 text-sm font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                      onClick={updateBalance}
                    >
                      Update Balance
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}
